import { SocialPlatformId } from '@app/modules/social-export/domain/platforms';
import { FragmentsCreateFragmentDtoQuickPublishedPlatformsEnumKey } from '@mi-front/api-v2';
import { PartialRecord } from '@mi-front/core';

/**
 * Collects platform ids that were toggled on for quick publish during fragment creation.
 */
export function getQuickPublishedPlatforms(
  platformUpload?: PartialRecord<SocialPlatformId, { enabled: boolean }>,
): FragmentsCreateFragmentDtoQuickPublishedPlatformsEnumKey[] {
  if (!platformUpload) {
    return [];
  }

  return (Object.keys(platformUpload) as SocialPlatformId[]).filter(
    (platformId) => platformUpload[platformId]?.enabled,
  );
}
